import { render, staticRenderFns } from "./PlayerSummary.vue?vue&type=template&id=608a1ba6&scoped=true&"
import script from "./PlayerSummary.vue?vue&type=script&lang=js&"
export * from "./PlayerSummary.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSummary.vue?vue&type=style&index=0&id=608a1ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a1ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VIcon,VList,VListItem,VSpacer,VTooltip})
